import { faArrowsRotate, faFilter, faHashtag } from "@fortawesome/free-solid-svg-icons";
import SubHeader from "../../Shared/SubHeader";
import { IconTextContainerStyle, SubContainerStyle } from "../../../styles/styles";
import { SLIDER_OPTIONS } from "../../../utils/consts";
import Slider from "../../Shared/Slider";
import { searchParamsObj, toSlug } from "../../../utils/dataHandler";
import { MapType, SelectedLayersType } from "../../../types/dataTypes";
import { LAYER_IDS } from "../../../utils/mapConsts";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Button from "../../Shared/Button";
import { Font } from "@react-pdf/renderer";
import styled from '@emotion/styled';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type FilterSectionProps = {
  map: MapType;
  numberSelectedSettlements: number;
}

function FilterSection({numberSelectedSettlements}: FilterSectionProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [sliderKey, setSliderKey] = useState(0);
  const sp = searchParamsObj(searchParams);
  const initialSliderVals = SLIDER_OPTIONS.map((option)=>({...option, minValInit: ((sp[`${option.param}_min`])?Number(sp[`${option.param}_min`]):(option.minValInit)), maxValInit: ((sp[`${option.param}_max`])?Number(sp[`${option.param}_max`]):(option.maxValInit))}))

  const handleResetFilters = () => {
    // Reset URL parameters
    SLIDER_OPTIONS.forEach(option => {
      searchParams.delete(`${option.param}_min`);
      searchParams.delete(`${option.param}_max`);
    });
    setSearchParams(searchParams);

    // Force re-render of sliders
    setSliderKey(prevKey => prevKey + 1);
  };

    return (
        <>
        <SubHeader text={'Filter Settlements'} icon={faFilter} />
        <SubContainerStyle>
        <FilterInfoStyle>
          <IconTextContainerStyle>
            <FontAwesomeIcon icon={faHashtag} />
            {numberSelectedSettlements} Settlements selected
          </IconTextContainerStyle>
          <Button onClick={handleResetFilters} icon={faArrowsRotate}/>
        </FilterInfoStyle>
        {initialSliderVals.map((opt, i) => {
              return (
                <Slider
                  key={`${sliderKey}-${i}`}
                  name={opt.text}
                  min={opt.min}
                  max={opt.max}
                  minValInit={opt.minValInit}
                  maxValInit={opt.maxValInit}
                  diff={1}
                  units={opt.units}
                  ariaLabel={toSlug(opt.text)}
                  urlParam={opt.param}
                  toolTipText={opt.tooltip_text}
                />
              );
            })}
        </SubContainerStyle>
        </>
    )
}

export const FilterInfoStyle = styled.div<{}>(
  () => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  `
);

export default FilterSection;